import * as XLSX from "xlsx";
import { templateCsv } from "@/lib/reference-data-csv";

/** Texto do toast de promote, citando as linhas curadas só quando houve alguma.
 *
 *  `healed_rows` é como a correção da S-046 fica visível: conta as linhas trazidas
 *  de volta do estado-base da run porque um rollback deixou a chave delas fora
 *  dele. Sem mostrar isso não há como distinguir "curou 2 chaves" de "nada
 *  precisava de cura" — a correção agiria às escondidas.
 */
export function promoteMessage(
  t: (key: string, opts?: Record<string, unknown>) => string,
  res: { activated_rows: number; demoted_rows: number; healed_rows?: number },
): string {
  const base = t("Promoted · {{a}} rows activated, {{d}} demoted.", {
    a: res.activated_rows,
    d: res.demoted_rows,
  });
  if (!res.healed_rows) return base;
  return `${base} ${t("{{h}} restored from the base version.", { h: res.healed_rows })}`;
}

export function triggerDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** CSV com uma só linha de cabeçalho com os nomes das colunas aceitas, separado por ';'
 *  como o parser do ingest (a serialização mora em `reference-data-csv`). */
export function downloadTemplateCsv(tableName: string, columns: string[]) {
  const blob = new Blob([templateCsv(columns)], { type: "text/csv;charset=utf-8" });
  triggerDownload(blob, `${tableName}_template.csv`);
}

/** Planilha xlsx cuja primeira (e única) linha são os nomes das colunas aceitas. */
export function downloadTemplateXlsx(tableName: string, columns: string[]) {
  const ws = XLSX.utils.aoa_to_sheet([columns]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "template");
  XLSX.writeFile(wb, `${tableName}_template.xlsx`);
}
